







































import { Component, Vue } from 'vue-property-decorator';

@Component({
  components: {}
})
export default class P0149 extends Vue {}
